/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetCustomerNameByInnModel,
  IGetCustomerNameByInnRequest,
  IMappers,
  IGetCustomerNameByInnResponse,
  IGetCustomerNameByInnResponseError,
  TGetCustomerNameByInnResponse,
} from './types';

const defaultConfig: TGetCustomerNameByInnModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'billing-accounts',
  pathApi: '/v1/get-customer-name-by-inn/',
  hostType: 'api',
} as TGetCustomerNameByInnModel;

function createGetCustomerNameByInnModel(parameters: IGetCustomerNameByInnRequest): TGetCustomerNameByInnModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetCustomerNameByInnOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetCustomerNameByInnRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetCustomerNameByInn<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetCustomerNameByInnOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetCustomerNameByInnResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetCustomerNameByInnModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetCustomerNameByInnResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetCustomerNameByInnResponseError);
    }
  }

  return { response, statusCode } as TGetCustomerNameByInnResponse;
}

export { defaultConfig, createGetCustomerNameByInnModel, fetchGetCustomerNameByInn };
